export const INCENTIVE_ACTIONS = {
  JOIN_WORKSPACE: 'join_workspace',
  RECORD_FIRST_VIDEO: 'record_first_video',
};

export const INCENTIVE_TYPES = {
  STORAGE: 'storage',
};

export const INCENTIVES_LIMIT_V1 = 475;

export const INCENTIVES_REWARDS_V1 = {
  PER_ACTION: {
    [INCENTIVE_ACTIONS.JOIN_WORKSPACE]: 25,
    [INCENTIVE_ACTIONS.RECORD_FIRST_VIDEO]: 25,
  },
  POSSIBLE: 50,
};

export const INCENTIVES_REWARDS_V2 = {
  PER_ACTION: {
    [INCENTIVE_ACTIONS.JOIN_WORKSPACE]: 10,
    [INCENTIVE_ACTIONS.RECORD_FIRST_VIDEO]: 10,
  },
  POSSIBLE: 20,
};

export const INCENTIVES_REWARDS_V3 = {
  PER_ACTION: {
    [INCENTIVE_ACTIONS.JOIN_WORKSPACE]: 50,
    [INCENTIVE_ACTIONS.RECORD_FIRST_VIDEO]: 50,
  },
  POSSIBLE: 100,
};

export const INCENTIVES_DEFAULT_V1 = {
  [INCENTIVE_ACTIONS.JOIN_WORKSPACE]: {
    type: INCENTIVE_TYPES.STORAGE,
    value: INCENTIVES_REWARDS_V1.PER_ACTION[INCENTIVE_ACTIONS.JOIN_WORKSPACE],
    completed: false,
  },
  [INCENTIVE_ACTIONS.RECORD_FIRST_VIDEO]: {
    type: INCENTIVE_TYPES.STORAGE,
    value:
      INCENTIVES_REWARDS_V1.PER_ACTION[INCENTIVE_ACTIONS.RECORD_FIRST_VIDEO],
    completed: false,
  },
};

export const INVITER_INCENTIVE_REWARD_TOTAL_DEFAULT_V1 = {
  total: 0,
  invitees: [],
};

export const STORAGE_INCENTIVES_VARIATIONS_REWARDS_V2 = {
  control: INCENTIVES_REWARDS_V1,
  'variation-1': INCENTIVES_REWARDS_V2,
  'variation-2': INCENTIVES_REWARDS_V3,
};

export const STORAGE_INCENTIVES_VARIATIONS_REWARDS_ROLLOUT = {
  variation: INCENTIVES_REWARDS_V1,
};

export const STORAGE_INCENTIVES_VARIATIONS_V2 = Object.keys(
  STORAGE_INCENTIVES_VARIATIONS_REWARDS_V2
);

export const STORAGE_INCENTIVES_VARIATIONS_ROLLOUT = Object.keys(
  STORAGE_INCENTIVES_VARIATIONS_REWARDS_ROLLOUT
);
